module.exports = "/ui/fonts/slick.eot";